import React, { Component } from 'react';
import { RotateCcw, Home } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { BaseErrorBoundary, ErrorFallbackProps } from './BaseErrorBoundary';
interface GlobalErrorBoundaryProps {
  children: React.ReactNode;
  onNavigateHome?: () => void;
}
/**
 * GlobalErrorBoundary — Catches rendering errors across the entire app shell.
 *
 * Now uses BaseErrorBoundary for shared lifecycle logic (s106 P2-18).
 */
export class GlobalErrorBoundary extends Component<GlobalErrorBoundaryProps> {
  handleGoHome = (): void => {
    this.props.onNavigateHome?.();
  };
  renderFallback = ({
    error,
    onReset
  }: ErrorFallbackProps): React.ReactNode => {
    return <div className="max-w-lg mx-auto mt-12 px-4" data-id="element-1763">
        <Card className="p-10 text-center shadow-2xl shadow-rose-100 border-2 border-rose-100 rounded-3xl" data-id="element-1764">
          <div className="text-6xl mb-6" data-id="element-1765">😕</div>
          <h2 className="text-3xl font-black text-slate-900 mb-3 tracking-tight" data-id="element-1766">
            Er ging iets mis
          </h2>
          <p className="text-slate-600 mb-6 text-lg leading-relaxed font-medium" data-id="element-1767">
            Deze pagina kon niet worden geladen. Probeer het opnieuw of ga terug
            naar het dashboard.
          </p>

          {process.env.NODE_ENV === 'development' && error && <div className="mb-6 p-4 bg-rose-50 rounded-xl border border-rose-200 text-left" data-id="element-1768">
              <p className="text-xs font-bold text-rose-800 mb-1" data-id="element-1769">Debug Info</p>
              <p className="text-xs font-mono text-rose-700 break-all" data-id="element-1770">
                {error.message}
              </p>
            </div>}

          <div className="flex gap-3 justify-center" data-id="element-1771">
            <Button onClick={onReset} variant="primary" size="xl" className="shadow-xl shadow-indigo-200" data-id="element-1772">
              <RotateCcw className="w-5 h-5 mr-2" data-id="element-1773" />
              Probeer opnieuw
            </Button>
            {this.props.onNavigateHome && <Button onClick={() => {
            onReset();
            this.handleGoHome();
          }} variant="secondary" size="xl" data-id="element-1774">
                <Home className="w-5 h-5 mr-2" data-id="element-1775" />
                Naar dashboard
              </Button>}
          </div>
        </Card>
      </div>;
  };
  render(): React.ReactNode {
    return <BaseErrorBoundary logPrefix="Global" fallback={this.renderFallback} data-id="element-1776">
        {this.props.children}
      </BaseErrorBoundary>;
  }
}